import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportsRoutingModule } from './reports-routing.module';
import { ReportsComponent } from './reports.component';
import { FormsModule } from '@angular/forms';
import { Trip2ThemeModule } from 'app/trip2-theme/trip2-theme.module';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import { PayorsService } from '../payors/payors.service';
import { ReportsService } from './reports.service';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';

@NgModule({
  imports: [
    CommonModule,
    ReportsRoutingModule,
    FormsModule,
    Trip2ThemeModule,
    MyDateRangePickerModule,
  ],
  declarations: [ReportsComponent],
  providers: [
    PayorsService,
    ReportsService],
  exports: [ReportsComponent]
})
export class ReportsModule { }



// WEBPACK FOOTER //
// ./src/app/pages/reports/reports.module.ts